export enum OutboundShipmentKind {
  CarrierShipment = "carrier-shipment",
  InternalShipment = "internal-shipment",
}
